export default __webpack_public_path__ + "static/workspace-desk-bg-red-b00f69f29cf56bbf7f1fbcc217bba6cb.png";